/* Moglee Base — product page behaviour: variant picker, sticky bar, gallery dots. */

(function () {
  var root = document.querySelector('[data-mb-variants]');
  var dataEl = document.querySelector('[data-mb-variant-json]');
  if (!root || !dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-mb-option]'));
  var idInput = document.querySelector('#mb-buy-form input[name="id"]');
  var buttons = Array.prototype.slice.call(document.querySelectorAll('.mb-buy__submit'));
  var priceBox = document.querySelector('[data-mb-price]');
  var stickyPrice = document.querySelector('.mb-sticky-buy__price');
  var gallery = document.querySelector('[data-mb-gallery]');

  function selectedValues() {
    return fieldsets.map(function (fs) {
      var select = fs.querySelector('select');
      if (select) return select.value;
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function matches(variant, values) {
    for (var i = 0; i < values.length; i++) {
      if (variant.options[i] !== values[i]) return false;
    }
    return true;
  }

  function findVariant(values) {
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], values)) return variants[i];
    }
    return null;
  }

  function hasAvailable(values) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available && matches(variants[i], values)) return true;
    }
    return false;
  }

  function markSoldOut(values) {
    fieldsets.forEach(function (fs, index) {
      var nodes = fs.querySelectorAll('input[type="radio"], option');
      Array.prototype.forEach.call(nodes, function (node) {
        var test = values.slice();
        test[index] = node.value;
        var soldOut = !hasAvailable(test);
        if (node.tagName === 'OPTION') {
          var label = node.getAttribute('data-label') || node.value;
          node.textContent = soldOut ? label + ' (sold out)' : label;
        } else if (node.nextElementSibling) {
          node.nextElementSibling.classList.toggle('is-soldout', soldOut);
        }
      });
    });
  }

  function renderPrice(variant) {
    if (priceBox) {
      while (priceBox.firstChild) priceBox.removeChild(priceBox.firstChild);
      if (variant.compare) {
        var mark = document.createElement('mark');
        mark.textContent = variant.price;
        var strike = document.createElement('s');
        strike.textContent = variant.compare;
        priceBox.appendChild(mark);
        priceBox.appendChild(document.createTextNode(' '));
        priceBox.appendChild(strike);
      } else {
        var span = document.createElement('span');
        span.textContent = variant.price;
        priceBox.appendChild(span);
      }
    }
    if (stickyPrice) stickyPrice.textContent = variant.price;
  }

  function update(userChanged) {
    var values = selectedValues();
    var variant = findVariant(values);

    fieldsets.forEach(function (fs, index) {
      var out = fs.querySelector('[data-mb-selected]');
      if (out) out.textContent = values[index];
    });

    markSoldOut(values);

    buttons.forEach(function (button) {
      var label = button.getAttribute('data-label') || 'Add to bag';
      if (!variant) {
        button.disabled = true;
        button.textContent = 'Unavailable';
      } else if (!variant.available) {
        button.disabled = true;
        button.textContent = 'Sold out';
      } else {
        button.disabled = false;
        button.textContent = label;
      }
    });

    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    renderPrice(variant);

    if (!userChanged) return;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    if (variant.media > 0 && gallery && gallery.scrollWidth > gallery.clientWidth + 1) {
      gallery.scrollTo({ left: gallery.clientWidth * (variant.media - 1), behavior: 'smooth' });
    }
  }

  root.addEventListener('change', function () {
    update(true);
  });

  update(false);
})();

(function () {
  var anchor = document.querySelector('[data-mb-buy-anchor]');
  var bar = document.querySelector('[data-mb-sticky-buy]');

  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        bar.setAttribute('data-visible', visible ? 'false' : 'true');
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { rootMargin: '0px 0px -10% 0px' }
    ).observe(anchor);
  }

  var gallery = document.querySelector('[data-mb-gallery]');
  var dots = document.querySelector('[data-mb-dots]');
  if (!gallery || !dots) return;

  var dotButtons = Array.prototype.slice.call(dots.querySelectorAll('button'));

  dotButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var index = parseInt(button.getAttribute('data-index'), 10);
      gallery.scrollTo({ left: gallery.clientWidth * index, behavior: 'smooth' });
    });
  });

  var frame = null;
  gallery.addEventListener(
    'scroll',
    function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dotButtons.forEach(function (button, position) {
          button.setAttribute('aria-current', position === index ? 'true' : 'false');
        });
      });
    },
    { passive: true }
  );
})();